import Paragraph from './Paragraph.component';

export default Paragraph;